import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import ClipboardCard from "./components/ClipboardCard";

// Pages 
import Faq from "./Pages/Faq";
import Blog from "./Pages/Blog";
import BlogDetails from "./Pages/BlogDetails";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Contact from "./Pages/Contact";
import About from "./Pages/about";
import Terms from "./Pages/terms";
import Disclaimer from "./Pages/disclaimer";


function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 dark:bg-gradient-to-b dark:from-[#050b1a] dark:via-[#0b1220] dark:to-[#0f172a] transition-colors">

        <Header />

        <main className="w-full">
          <Routes>

            <Route path="/" element={<ClipboardCard />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/Blog/:slug" element={<BlogDetails />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />

          </Routes>
        </main>

      </div>
    </Router>
  );
}

export default App;